import { render, staticRenderFns } from "./Events4.vue?vue&type=template&id=306e9103"
import script from "./Events4.vue?vue&type=script&lang=ts"
export * from "./Events4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports